module.exports = __webpack_public_path__ + "img/fzzh.27e083e0.png";